import "./App.css";
import Homepage from "./components/homepage/homepage";
import {
  AppBar,
  Button,
  Stack,
  Toolbar,
  Typography,
} from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Login from "./components/login";
import ClientCredientialsLogin from "./components/client";
import AppBarLabel from "./components/toolbar";
import OAuthLogin from "./components/oAuth";
import { Provider } from "react-redux";

import AuthStore, { Persistor } from "./store/store";
import CognitoLogin from "./components/login/cognito-login";
import ProtactRoute from "./components/protactor/protact";
import NotFound from "./components/protactor/404";
import { PersistGate } from "redux-persist/integration/react";
const darkTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#1976d2",
    },
  },
});

function App() {
  
  return (
    <Provider store={AuthStore}>
      <PersistGate loading = {null} persistor={Persistor}>
      <React.Fragment>
        <ThemeProvider theme={darkTheme}>
          <Stack spacing={2} sx={{ flexGrow: 1 }}>
            <AppBar position="fixed" color="primary" enableColorOnDark>
              <AppBarLabel
                
                label="Demo Airways - Skywise API"
                
              />
            </AppBar>
          </Stack>
          <Stack mt={13} spacing={2} sx={{ flexGrow: 1 }}>
            <Routes>
              <Route
                path="/"
                element={<Navigate to="/cognito-login" replace />}
              />
              <Route path="/cognito-login" element={<CognitoLogin />} />
              
              <Route
                path="/login"
                element={
                  <ProtactRoute
                    component={Login}
                    requiredCognitoAuth={true}
                                     
                  />
                }
              />
              <Route
                exact
                path="/client_login"
                element={
                  <ClientCredientialsLogin
                  />
                }
              ></Route>
              <Route
                exact
                path="/oauth_login"
                element={<OAuthLogin />}
              ></Route>
              <Route
                path="/home"
                element={
                  <ProtactRoute
                    component={Homepage}
                    requiredCognitoAuth={true}
                  />
                }
              />
              <Route path="/404" element={<NotFound />} />
              <Route path="*" element={<Navigate to="/404" replace />} />
            </Routes>
          </Stack>
        </ThemeProvider>
      </React.Fragment>
      </PersistGate>
    </Provider>
  );
}

export default App;
